import React, { useState, useEffect } from 'react';
import Icon from 'icon';
import Img from 'img';
import Container from 'container';
import Button from 'button';
import s from './header.module.scss';

const links = [
  {
    name: 'HOME',
    href: '/'
  },
  {
    name: 'ABOUT',
    href: '/about/'
  },
  {
    name: 'FAQ',
    href: '/faq/'
  },
  {
    name: 'BLOG',
    href: '/cannabition-blog/'
  },
  {
    name: 'VISIT',
    href: '/visit/'
  },
  {
    name: 'PRIVATE EVENTS',
    href: '/events/'
  }
];

export default function Header({ stage, hash, setModalOn }) {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState(false);

  const showPopup = () => {
    setShow(true);
  };

  const showBlackHeader = () => {
    if (hash === '#exhibits' && stage === 0) {
      return true;
    }
    if (hash === '#contact') {
      return true;
    }
    return false;
  };

  const handleMenu = () => {
    if (open) {
      setTimeout(() => {
        setDisplay(false);
      }, 300);
    } else {
      setDisplay(true);
    }
    setTimeout(() => {
      setOpen(!open);
    }, 10);
  };

  return (
    <Container className={s.header}>
      <div className={s.wrapper}>
        <ul
          className={`${s.menu} ${open ? s.open : ''} ${
            display ? s.display : ''
          }`}
        >
          {links.map(({ name, href }) => (
            <li className={s.menuLink}>
              <a href={href}>{name}</a>
            </li>
          ))}
        </ul>
        <a href="#welcome">
          <Img
            src={
              showBlackHeader() ? 'cannabition-logo-green' : 'cannabition-logo'
            }
            png
            className={s.img}
            height="auto"
            width="100%"
            onClick={() => window.scrollTo(0, 0)}
          />
        </a>
        <div className={s.buttons}>
          <button className={s.menuButton} onClick={() => handleMenu()}>
            <Icon icon="bars" className={s.bars} />
            MENU
          </button>
      
        </div>
      </div>
    </Container>
  );
}
